import { CSSProperties } from 'react';

import { colors } from '@verantos-dev/shared-ui-components/tokens';

import batchProcessingImage from './images/batchprocessing_status.svg';
import cohortDraftImage from './images/cohortDraft.svg';
import cohortErrorImage from './images/cohortError.svg';
import cohortFinalImage from './images/cohortFinal.svg';
import cohortProcessedImage from './images/cohortProcessed.svg';
import cohortProcessingImage from './images/cohortProcessing.svg';
import failedImage from './images/failed_status.svg';
import processedImage from './images/processed_status.svg';

export const STATUS_LABEL_MAPPING: Record<string, string> = {
  active: 'Active',
  available: 'Available',
  final: 'Final',
  processing: 'Processing',
  pending: 'Pending',
  locked: 'Locked',
  in_design: 'In Design',
  draft: 'Draft',
  error: 'Error',
  enrolled: 'Enrolled',
  bypass: 'Bypass',
  ready: 'Ready',
  received: 'Received',
  rejected: 'Rejected',
  processed: 'Processed',
  failed: 'Failed',
  batch_processing: 'Processing',
  cohortstatusfinal: 'Final',
  cohortstatusprocessing: 'Processing',
  cohortstatusprocessed: 'Processed',
  cohortstatusdraft: 'Draft',
  cohortstatuserror: 'Error',
  cohortstatusunsaved: 'Draft',
};

export const STATUS_BACKGROUND_MAPPING: Record<string, CSSProperties> = {
  // TODO: no VDS token for this value — needs designer input (#00800099 active with opacity) // VDS - raw token
  active: { backgroundColor: '#00800099' },
  // TODO: no VDS token for this value — needs designer input (#659d1f available) // VDS - raw token
  available: { backgroundColor: '#659d1f' },
  final: { backgroundColor: colors['primary-300'] }, // VDS - raw token
  processing: { backgroundColor: colors['secondary-500'] }, // VDS - raw token
  pending: { backgroundColor: colors['warning-500'] }, // VDS - raw token
  // TODO: no VDS token for this value — needs designer input (#252a36 locked) // VDS - raw token
  locked: { backgroundColor: '#252a36' },
  in_design: { backgroundImage: `url("${cohortDraftImage}")` },
  draft: { backgroundImage: `url("${cohortDraftImage}")` },
  error: { backgroundColor: colors['error-500'] }, // VDS - raw token
  // TODO: no VDS token for this value — needs designer input (#008800 enrolled, success-500 is #008000) // VDS - raw token
  enrolled: { backgroundColor: '#008800' },
  bypass: { backgroundColor: colors['primary-500'] }, // VDS - raw token
  ready: { backgroundColor: colors['success-500'] }, // VDS - raw token
  received: { backgroundColor: colors['secondary-500'] }, // VDS - raw token
  rejected: { backgroundColor: colors['error-500'] }, // VDS - raw token
  processed: { backgroundImage: `url("${processedImage}")` },
  failed: { backgroundImage: `url("${failedImage}")` },
  batch_processing: { backgroundImage: `url("${batchProcessingImage}")` },
  cohortstatusfinal: { backgroundImage: `url("${cohortFinalImage}")` },
  cohortstatusprocessing: { backgroundImage: `url("${cohortProcessingImage}")` },
  cohortstatusprocessed: { backgroundImage: `url("${cohortProcessedImage}")` },
  cohortstatusdraft: { backgroundImage: `url("${cohortDraftImage}")` },
  cohortstatuserror: { backgroundImage: `url("${cohortErrorImage}")` },
  cohortstatusunsaved: { backgroundImage: `url("${cohortDraftImage}")` },
};
